import React from "react";
import Image from "next/image";
import styled from "styled-components";
import NextLink from "next/link";
import {
  Box,
  Button,
  Link,
  Flex,
  LinkOverlay,
  LinkBox,
} from "@chakra-ui/react";
import { EmailIcon, PhoneIcon } from "@chakra-ui/icons";

import { ITeamMemberFields } from "src/types/generated/contentful";
import FlexDisplayItem from "../../../atoms/FlexDisplayItem";
import Heading from "../../../atoms/Heading";
import { AssetFields } from "contentful";
type TeamMemberProps = { "data-layoutid"?: string } & ITeamMemberFields;

export let formatPhoneNumber = (str: string): string => {
  //Filter only numbers from the input
  let cleaned = ("" + str).replace(/\D/g, "");

  //Check if the input is of correct
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    let intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }

  return "";
};

export default function CardLayout({
  phone,
  email,
  name,
  jobTitle,
  bio,
  slug,
  accreditationImage,
  licenseNumbers,
  nationalProducerNumber,
  profileImage,
}: TeamMemberProps) {
  const profileImagef = profileImage?.fields as AssetFields;
  const imageUrl = profileImagef ? `https:${profileImagef?.file?.url}` : "";

  return (
    <StylingWrapperCard
      fh="center"
      fv="center"
      textAlignment="center"
      themeName="Light Card with Shadow, 1/3 wide"
    >
      <Flex direction="column" alignItems="center">
        <LinkBox>
          <NextLink href={"/team-member/" + slug} passHref legacyBehavior>
            <LinkOverlay>
              <Flex justifyContent="center">
                {imageUrl ? (
                  <Image
                    alt={`${name} head shot`}
                    src={imageUrl}
                    height={100}
                    width={100}
                  />
                ) : null}
              </Flex>

              <CardNameHeading
                style={{ margin: "1em 0 0 0" }}
                flexDisplayHorizontalAlignment="Center"
                flexDisplayVerticalAlignment="Center"
                textAlignment="Center"
                level={2}
              >
                {name}
              </CardNameHeading>
            </LinkOverlay>
          </NextLink>
        </LinkBox>

        <Flex
          flexDirection={["column", "row", "column", "row"]}
          gap="2"
          wrap="wrap"
          alignItems="center"
          justifyContent="center"
        >
          <Button
            data-chakra-link
            variant="brand-outline-accent"
            size="sm"
            leftIcon={<EmailIcon />}
          >
            <Link href={`mailto:${email}`}>Email</Link>
          </Button>

          <Button
            data-chakra-link
            variant="brand-outline-accent"
            size="sm"
            leftIcon={<PhoneIcon />}
          >
            <Link href={`tel:${phone}`}>Phone</Link>
          </Button>
        </Flex>
      </Flex>
    </StylingWrapperCard>
  );
}

const StylingWrapperCard = styled(FlexDisplayItem)`
  h2 {
    font-size: calc(${({ theme }) => theme.typography.h2.fontSize}rem - 1.5rem);
    line-height: calc(
      ${({ theme }) => theme.typography.h2.fontSize}rem - 1.5rem
    );
    padding: 0;
    margin: 0;
  }

  a {
    font-size: 0.8rem;
  }

  padding: 2em;
`;

const CardNameHeading = styled(Heading)`
  font-size: 1.2rem;
`;
